import { StyleSheet } from "@react-pdf/renderer";
import type { TemplateStyles } from "@/interfaces";

export const Empty: TemplateStyles = StyleSheet.create({
  page: {},
  header: {},
  name: {},
  title: {},
  contactInfo: {},
  contactItem: {},
  contactIcon: {},
  section: {},
  sectionTitle: {},
  summary: {},
  skillsContainer: {},
  skillItem: {},
  skillItemBold: {},
  skillSeparator: {},
  itemContainer: {},
  itemHeader: {},
  itemTitle: {},
  itemSubtitle: {},
  itemDate: {},
  itemDescription: {},
  bulletList: {},
  bulletItem: {},
  bullet: {},
  languagesList: {},
  languageItem: {},
  languageName: {},
  languageLevelContainer: {},
  languageLevel: {},
  separator: {},
});
